'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
require('./constants-0cf35288.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
require('./svg-icon-501cae97.js');
var caretDownMui = require('./caret-down-mui-47d038ef.js');
require('./enums-de2d9d36.js');
var useBooleanState_hook = require('./use-boolean-state.hook-8d04931f.js');
var button = require('./button-d7f037ee.js');
var paper = require('./paper-e6cfe656.js');
var popover = require('./popover-c51645b1.js');

var StyledButton = styled__default(button.Button)(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  justify-content: flex-end;\n  min-width: 160px;\n  min-height: 40px;\n  text-transform: uppercase;\n"], ["\n  display: flex;\n  justify-content: flex-end;\n  min-width: 160px;\n  min-height: 40px;\n  text-transform: uppercase;\n"])));
var DownIcon = styled__default(caretDownMui.CaretDownMUI)(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  color: ", ";\n  margin-left: 16px;\n"], ["\n  color: ", ";\n  margin-left: 16px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminGreyLight;
});
var BaseButton = function (props) { return (React__default.createElement(StyledButton, tslib_es6.__assign({ Icon: React__default.createElement(DownIcon, null) }, props))); };
var templateObject_1, templateObject_2;

var ButtonOption = styled__default.button(templateObject_1$1 || (templateObject_1$1 = tslib_es6.__makeTemplateObject(["\n  background-color: ", ";\n  border: none;\n  min-height: 48px;\n  text-align: left;\n  padding: 0 16px;\n  font-family: ", ";\n  font-size: 14px;\n  line-height: 22px;\n  color: ", ";\n  cursor: pointer;\n"], ["\n  background-color: ", ";\n  border: none;\n  min-height: 48px;\n  text-align: left;\n  padding: 0 16px;\n  font-family: ", ";\n  font-size: 14px;\n  line-height: 22px;\n  color: ", ";\n  cursor: pointer;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.universal.transparent;
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.fontColor;
});
var ButtonOptions = function (_a) {
    var options = _a.options, dataCy = _a.dataCy;
    return (React__default.createElement(React__default.Fragment, null, options.map(function (_a) {
        var value = _a.value, label = _a.label;
        return (React__default.createElement(ButtonOption, { key: value, "data-value": value, type: "button", "data-cy": dataCy + "-" + value }, label));
    })));
};
var templateObject_1$1;

var StyledPaper = styled__default(paper.Paper)(templateObject_1$2 || (templateObject_1$2 = tslib_es6.__makeTemplateObject(["\n  min-width: 100%;\n\n  border: 1px solid ", ";\n  width: auto;\n  height: auto;\n  display: flex;\n  flex-direction: column;\n"], ["\n  min-width: 100%;\n\n  border: 1px solid ", ";\n  width: auto;\n  height: auto;\n  display: flex;\n  flex-direction: column;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminGreyLight;
});
var StyledPopover = styled__default(popover.Popover)(templateObject_2$1 || (templateObject_2$1 = tslib_es6.__makeTemplateObject(["\n  min-width: 100%;\n"], ["\n  min-width: 100%;\n"])));
var ButtonWithOptions = function (_a) {
    var text = _a.text, options = _a.options, onClick = _a.onClick, dataCy = _a.dataCy, _b = _a.BaseButtonComponent, BaseButtonComponent = _b === void 0 ? BaseButton : _b, _c = _a.PaperProps, PaperProps = _c === void 0 ? {} : _c, _d = _a.PopoverProps, PopoverProps = _d === void 0 ? {} : _d;
    var _e = useBooleanState_hook.useBooleanState(), isOpened = _e.value, closePopover = _e.setFalse, togglePopover = _e.toggle;
    var handleButtonClick = React.useCallback(function (event) {
        onClick(event.target.dataset.value);
        closePopover();
    }, [onClick, closePopover]);
    return (React__default.createElement(StyledPopover, tslib_es6.__assign({ open: isOpened, onClose: closePopover, buttonComponent: (React__default.createElement(BaseButtonComponent, { text: text, onClick: togglePopover, dataCy: dataCy })), position: "bottom", alignment: "end" }, PopoverProps),
        React__default.createElement(StyledPaper, tslib_es6.__assign({ onClick: handleButtonClick, borderRadius: "sm", depth: 2 }, PaperProps),
            React__default.createElement(ButtonOptions, { options: options, dataCy: dataCy }))));
};
var templateObject_1$2, templateObject_2$1;

exports.ButtonWithOptions = ButtonWithOptions;
